/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Product_LineInputs */

const tr_landing_telegram_mock_product_line = /** @type {(inputs: Landing_Telegram_Mock_Product_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim · M · Siyah`)
};

const en_landing_telegram_mock_product_line = /** @type {(inputs: Landing_Telegram_Mock_Product_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim · M · Black`)
};

const de_landing_telegram_mock_product_line = /** @type {(inputs: Landing_Telegram_Mock_Product_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim · M · Schwarz`)
};

const ru_landing_telegram_mock_product_line = /** @type {(inputs: Landing_Telegram_Mock_Product_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Футболка Slim · M · Чёрная`)
};

/**
* | output |
* | --- |
* | "T-Shirt Slim · M · Black" |
*
* @param {Landing_Telegram_Mock_Product_LineInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_product_line = /** @type {((inputs?: Landing_Telegram_Mock_Product_LineInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Product_LineInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_product_line(inputs)
	if (locale === "de") return de_landing_telegram_mock_product_line(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_product_line(inputs)
	return tr_landing_telegram_mock_product_line(inputs)
});